import { ppdtOne } from "./ppdtTestResponse";
import { ppdtTwo } from "./ppdtTestResponse";
import { ppdtThree } from "./ppdtTestResponse";
import { ppdtFour } from "./ppdtTestResponse";
import { ppdtFive } from "./ppdtTestResponse";
import { ppdtSix } from "./ppdtTestResponse";
import { ppdtSeven } from "./ppdtTestResponse";
import { ppdtEight } from "./ppdtTestResponse";
import { ppdtNine } from "./ppdtTestResponse";
import { ppdtTen } from "./ppdtTestResponse";

export const ppdtResponses = {
  one: ppdtOne,
  two: ppdtTwo,
  three: ppdtThree,
  four: ppdtFour,
  five: ppdtFive,
  six: ppdtSix,
  seven: ppdtSeven,
  eight: ppdtEight,
  nine: ppdtNine,
  ten: ppdtTen,
};
